import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../providers/auth_provider';

export default function Overview() {
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedDays, setSelectedDays] = useState(1); // Default to last week
    const { token, adminData } = useAuth();

    const fetchAudits = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/audit/getall/user`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    days: selectedDays,
                },
            });
            setActivities(response.data.audits);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAudits();
    }, [selectedDays]);

    const handleDateFilter = (days) => {
        setSelectedDays(days);
    };

    return (
        <>
            {/* User Profile Content */}
            <div className="row">
                <div className="col-xl-4 col-lg-5 col-md-5">
                    {/* About User */}
                    <div className="card mb-6">
                        <div className="card-body">
                            <small className="card-text text-uppercase text-muted small">
                                About
                            </small>
                            <ul className="list-unstyled my-3 py-1">
                                <li className="d-flex align-items-center mb-4">
                                    <i className="ri-user-3-line ri-24px" />
                                    <span className="fw-medium mx-2">Full Name:</span>{" "}
                                    <span>{adminData?.first_name + ' ' + adminData?.last_name}</span>
                                </li>
                                <li className="d-flex align-items-center mb-4">
                                    <i className="ri-check-line ri-24px" />
                                    <span className="fw-medium mx-2">Status:</span>{" "}
                                    <span className={`text-capitalize badge rounded-pill lh-xs ${adminData?.status === "active" ? "bg-label-success" : adminData?.status === "inactive" ? "bg-label-warning" : "bg-label-danger"}`}>
                                        {adminData?.status}
                                    </span>
                                </li>
                                <li className="d-flex align-items-center mb-4">
                                    <i className="ri-star-smile-line ri-24px" />
                                    <span className="fw-medium mx-2">Role:</span>{" "}
                                    <span>Super Admin</span>
                                </li>
                            </ul>
                            <small className="card-text text-uppercase text-muted small">
                                Contacts
                            </small>
                            <ul className="list-unstyled my-3 py-1">
                                <li className="d-flex align-items-center mb-4">
                                    <i className="ri-phone-line ri-24px" />
                                    <span className="fw-medium mx-2">Contact:</span>{" "}
                                    <span>{adminData?.phone_no}</span>
                                </li>
                                <li className="d-flex align-items-center mb-2">
                                    <i className="ri-mail-open-line ri-24px" />
                                    <span className="fw-medium mx-2">Email:</span>{" "}
                                    <span>{adminData?.email}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/*/ About User */}
                </div>
                {/* <div className="col-xl-8 col-lg-7 col-md-7">
                    <div className="card card-action mb-6">
                        <div className="card-header align-items-center">
                            <h5 className="card-action-title mb-0">
                                <i className="ri-bar-chart-2-line ri-24px text-body me-4" />
                                Activity Timeline
                            </h5>
                            <div className="card-action-element">
                                <div className="dropdown">
                                    <button
                                        type="button"
                                        className="btn dropdown-toggle hide-arrow p-0"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <i className="ri-more-2-line ri-22px text-muted" />
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end">
                                        <li>
                                            <button className="dropdown-item" onClick={() => handleDateFilter(1)}>
                                                Today
                                            </button>
                                        </li>
                                        <li>
                                            <button className="dropdown-item" onClick={() => handleDateFilter(7)}>
                                                Last Week
                                            </button>
                                        </li>
                                        <li>
                                            <button className="dropdown-item" onClick={() => handleDateFilter(30)}>
                                                Last Month
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {loading ? (
                            <div className="d-flex justify-content-center align-items-center py-5">
                                <div className="spinner-border text-light" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="card-body pt-5 overflow-auto" style={{ maxHeight: '30rem', scrollbarWidth: "none" }}>
                                {activities.length > 0 ? (
                                    <ul className="timeline mb-0">
                                        {activities.map(activity => (
                                            <li key={activity.id} className="timeline-item timeline-item-transparent">
                                                <span className={`timeline-point ${getTimelinePointClass(activity.action)}`} />
                                                <div className="timeline-event">
                                                    <div className="timeline-header mb-3">
                                                        <h6 className="mb-0">{activity.details}</h6>
                                                        <small className="text-muted">{formatTime(activity.created_at)}</small>
                                                    </div>
                                                    <p className="mb-2">
                                                        {activity.action} {activity.target_type} #{activity.target_id}
                                                    </p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <div className="text-center py-5">
                                        <h4 className="mb-4">No records found</h4>
                                        <p className="mb-0">
                                            No activity has been done yet
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div> */}
            </div>
            {/*/ User Profile Content */}
        </>
    );
}

// Helper functions to format time and determine the timeline point class based on the action type
function formatTime(time) {
    const date = new Date(time);
    const day = `0${date.getDate()}`.slice(-2);
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const year = date.getFullYear();
    const hour = `0${date.getHours()}`.slice(-2);
    const minute = `0${date.getMinutes()}`.slice(-2);
    return `${day}/${month}/${year} ${hour}:${minute}`;
}

function getTimelinePointClass(action) {
    switch (action) {
        case 'created':
            return 'timeline-point-success';
        case 'updated':
            return 'timeline-point-info';
        case 'deleted':
            return 'timeline-point-danger';
        default:
            return 'timeline-point-primary';
    }
}
